import { createSelector } from 'reselect';

const MAX_UNPINNED_NOTIFICATIONS = 3;

const selectAllNotifications = (state) =>
  state?.notificationState?.notifications ?? [];

// => renvoie la MÊME référence tant que `notifications` n'a pas changé par RÉFÉRENCE
export const notificationsSelector = createSelector(
  [selectAllNotifications],
  (notifications) => {
    // split sans recréer plus que nécessaire
    const pinned = [];
    const unpinned = [];
    for (const n of notifications) {
      (n?.isPinned ? pinned : unpinned).push(n);
    }

    // on veut les 3 non épinglées les plus récentes (createdAt plus grand)
    const recentUnpinned = unpinned
      .slice() // copie pour ne pas muter
      .sort((a, b) => b.createdAt - a.createdAt)
      .slice(0, MAX_UNPINNED_NOTIFICATIONS);

    // concat + tri final croissant (si tu préfères décroissant, inverse)
    const result = [...pinned, ...recentUnpinned].sort(
      (a, b) => a.createdAt - b.createdAt
    );

    return result;
  }
);
